import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Icon as RIcon } from "react-icons-kit";
import { checkCircle, edit } from "react-icons-kit/fa";
import {
  getInformation,
  updateAvailability,
  updateDayAndTime,
  updateInfo
} from "../../action/informationAction";
import {
  Card,
  ListGroup,
  ListGroupItem,
  Col,
  Row,
  Table,
  Button
} from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import EditModel from "./EditModel";
import Home from "./../Home";
const Information = (props) => {
  const dispatch = useDispatch();
  const state = useSelector(state => state.information)
  useEffect(() => {
    props.getInformation();
  }, []);
  let [isBranchActive, setIsBranchActive] = useState(false);
  let [allDays, setAllDays] = useState([]);
  let [show, setShow] = useState(false);
  const {
    name,
    availability,
    sunday,
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    phoneNo,
    email,
    website,
    taxNo,
    accountNumber,
    address,
    description
  } = props.details;
  const { successData } = props;
  useEffect(() => {
    if (availability) {
      setIsBranchActive(availability.status);
    }
    if (sunday)
      setAllDays([
        { ...monday, day: "Monday", disabled: false },
        { ...tuesday, day: "Tuesday", disabled: false },
        { ...wednesday, day: "Wednesday", disabled: false },
        { ...thursday, day: "Thursday", disabled: false },
        { ...friday, day: "Friday", disabled: false },
        { ...saturday, day: "Saturday", disabled: false },
        { ...sunday, day: "Sunday", disabled: false }
      ]);
  }, [props.details]);

  const empType = localStorage.getItem("empType");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    if (
      successData &&
      Object.keys(successData).length !== 0 &&
      successData.actionType === "updateInfo"
    ) {
      handleClose();
      props.getInformation();
    }
  }, [successData]);

  const toggleBranchStatus=(e)=>{
    setIsBranchActive(e)
    props.updateAvailability({ value: e })
  }
  const getAllDays = () => {
    return (
      allDays.length &&
      allDays.map((day, i) => {
        if (day)
          return (
            <Col md={3} key={i} className="m-b-1" style={{ fontSize: "20px" }}>
              <Card key={i}>
                <Card.Body>
                  <p style={{ marginBottom: "0.2em" }}>
                    {day.status ? (
                      <RIcon
                        style={{ color: "green" }}
                        icon={checkCircle}
                        size={18}
                      />
                    ) : (
                      <RIcon
                        style={{ color: "red" }}
                        icon={checkCircle}
                        size={18}
                      />
                    )}{" "}
                    {day.day}
                  </p>
                  <p style={{ marginBottom: "0.2em" }}>
                    {day.openingTime}-{day.closingTime}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          );
      })
    );
  };
  return (
    <Home>
      <div className="report-container text-center">
        <span className="item ">{name} Detaljer</span>
      </div>
      <Card>
        <ListGroup className="list-group-flush">
          <ListGroupItem>
            <Row>
              <Col>
                <h4 className="text-right">Online Tilgjengelighet :</h4>
              </Col>
              <Col>
                <BootstrapSwitchButton
                  checked={isBranchActive}
                  onChange={(e) =>{toggleBranchStatus(e)}}
                  onlabel="Active"
                  offlabel="Inactive"
                  onstyle="btn-ab"
                  style="btn-ab"
                  width={100}
                />
              </Col>

              {empType === "MANAGER" ? (
                <Col>
                  <Button className="btn-ab float-right" onClick={handleShow}>
                    <RIcon style={{ color: "green" }} icon={edit} size={18} />
                  </Button>{" "}
                </Col>
              ) : (
                ""
              )}
            </Row>
          </ListGroupItem>
          <ListGroupItem>
            <Row>
              <Col>
                <h4>Uke Tilgjengelighet :</h4>
              </Col>
            </Row>
            <Row>{getAllDays()}</Row>
          </ListGroupItem>
          <ListGroupItem>
            <Row className="justify-content-md-center">
              <Col md={6}>
                <Table striped bordered hover>
                  <tbody>
                    <tr>
                      <th>Tel. Nr:</th>
                      <td>{phoneNo}</td>
                    </tr>
                    <tr>
                      <th>Email:</th>
                      <td>{email}</td>
                    </tr>
                    <tr>
                      <th>Nettsted:</th>
                      <td>
                        <a href={website} target="_blank">
                          {website}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>Org. Nr.</th>
                      <td>{taxNo}</td>
                    </tr>
                    <tr>
                      <th>Konto Nr:</th>
                      <td>{accountNumber}</td>
                    </tr>
                    <tr>
                      <th>Addresse:</th>
                      <td>
                        {address && address.line1 ? address.line1 : ""}
                        <br />
                        {address && address.line2 ? address.line2 : ""}
                        <br />
                        {address && address.city ? address.city : ""},
                        {address && address.state ? address.state : ""}
                        <br />
                        {address && address.pin ? address.pin : ""},
                        {address && address.country ? address.country : ""}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <b>Om-Oss:</b>
                      </th>
                      <td>{description}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </ListGroupItem>
        </ListGroup>
      </Card>
      <EditModel
        handleClose={handleClose}
        show={show}
        allDays={allDays}
        details={props.details}
        setAllDays={setAllDays}
        updateDayAndTime={props.updateDayAndTime}
        updateInfo={props.updateInfo}
      />
    </Home>
  );
};
const mapStateToProps = ({ information, successMassage }) => {
  return { details: information, successData: successMassage.data };
};
export default connect(mapStateToProps, {
  getInformation,
  updateAvailability,
  updateDayAndTime,
  updateInfo
})(Information);
